"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEAD_ROW_CATEGORY_KEY = 'base';
exports.HEAD_ROW_PARENT_COMPONENT_KEY = 'table';
exports.HEAD_ROW_COMPONENT_KEY = 'headRow';